(() => {
  const mounted = new WeakMap();
  function mount(section, setup) {
    if (mounted.has(section)) return;
    const cleanups = [];
    const on = (target, type, fn, options) => {
      target.addEventListener(type, fn, options);
      cleanups.push(() => target.removeEventListener(type, fn, options));
    };
    setup(on, cleanups);
    mounted.set(section, () => cleanups.forEach(fn => fn()));
  }
  function init(root = document) {
    root.querySelectorAll('[data-haiyi-guides]').forEach(section => mount(section, (on, cleanups) => {
      const track = section.querySelector('[data-guide-track]');
      const controls = section.querySelector('[data-guide-controls]');
      if (!track || !controls) return;
      const prev = controls.querySelector('[data-guide-prev]'), next = controls.querySelector('[data-guide-next]');
      controls.hidden = false;
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      [prev,next].forEach((button,i) => on(button,'click',() => {
        const card = track.firstElementChild;
        if (card) track.scrollBy({left:(card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)) * (i ? 1 : -1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      on(track,'scroll',update,{passive:true});
      const resize = new ResizeObserver(update); resize.observe(track);
      cleanups.push(() => resize.disconnect()); update();
      section.querySelectorAll('[data-guide-preview-link]').forEach(link => {
        const params = new URLSearchParams(location.search), theme = window.Shopify && window.Shopify.theme;
        const previewId = params.get('preview_theme_id') || (theme && theme.role !== 'main' ? theme.id : null);
        if (previewId) { const url = new URL(link.href); url.searchParams.set('preview_theme_id',previewId); link.href=url.href; }
      });
    }));
    root.querySelectorAll('[data-haiyi-guide-page]').forEach(section => mount(section, (on, cleanups) => {
      const toc = section.querySelector('[data-guide-toc]');
      const header = document.querySelector('store-header');
      const mobile = matchMedia('(max-width:999px)');
      const setOffset = () => {
        const full = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const visible = header ? header.getBoundingClientRect().height : 0;
        section.style.setProperty('--hg-offset', Math.ceil(Math.max(full,visible,150)+24)+'px');
      };
      setOffset();
      if (header) { const resize = new ResizeObserver(setOffset);resize.observe(header);cleanups.push(()=>resize.disconnect()); }
      const sync = () => { if (toc) toc.open = !mobile.matches; setOffset(); };
      on(mobile,'change',sync); sync();
      if (toc) on(toc,'toggle',() => { if (!mobile.matches && !toc.open) toc.open=true; });
      const links = [...section.querySelectorAll('.haiyi-guide-page__toc a')];
      links.forEach(link => on(link,'click',event => {
        const target = section.querySelector(link.hash);
        if (!target) return;
        event.preventDefault();
        if (mobile.matches && toc) toc.open=false;
        requestAnimationFrame(() => {
          setOffset();
          target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
          history.replaceState(null,'',link.hash);
        });
      }));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) links.forEach(link => {
            if (link.hash==='#'+entry.target.id) link.setAttribute('aria-current','location');
            else link.removeAttribute('aria-current');
          });
        }),{rootMargin:'-25% 0px -65% 0px'});
        section.querySelectorAll('.hg-chapter h2[id]').forEach(el=>observer.observe(el));
        cleanups.push(()=>observer.disconnect());
      }
    }));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-haiyi-guides],[data-haiyi-guide-page]').forEach(section=>{const cleanup=mounted.get(section);if(cleanup)cleanup();mounted.delete(section);}));
})();
